import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const VerifyAccountPage = lazy(() => import("./VerifyAccountPage"));

const VerifyAccountPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <VerifyAccountPage />
    </Suspense>
  );
};

export default VerifyAccountPageLazy;
